import { z } from 'zod';

// ── Tenant settings ────────────────────────────────────────────────

export const tenantSettingsSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  timezone: z.string().default('UTC'),
  dateFormat: z.string().default('YYYY-MM-DD'),
  cursorApiKeyRef: z.string().min(1).nullish(),
});
export type TenantSettings = z.infer<typeof tenantSettingsSchema>;

export const updateTenantSettingsSchema = z.object({
  timezone: z.string().optional(),
  dateFormat: z.string().optional(),
  cursorApiKeyRef: z.string().min(1).nullish(),
});
export type UpdateTenantSettings = z.infer<typeof updateTenantSettingsSchema>;

// ── Model pricing ──────────────────────────────────────────────────

export const modelPricingSchema = z.object({
  id: z.string().uuid(),
  modelId: z.string().min(1),
  label: z.string().min(1),
  costInPer1M: z.coerce.number().min(0).default(0),
  costOutPer1M: z.coerce.number().min(0).default(0),
});
export type ModelPricing = z.infer<typeof modelPricingSchema>;

export const createModelPricingSchema = z.object({
  modelId: z.string().min(1),
  label: z.string().min(1),
  costInPer1M: z.coerce.number().min(0).default(0),
  costOutPer1M: z.coerce.number().min(0).default(0),
});
export type CreateModelPricing = z.infer<typeof createModelPricingSchema>;

export const updateModelPricingSchema = z.object({
  label: z.string().min(1).optional(),
  costInPer1M: z.coerce.number().min(0).optional(),
  costOutPer1M: z.coerce.number().min(0).optional(),
});
export type UpdateModelPricing = z.infer<typeof updateModelPricingSchema>;
